define.alias("ember-power-select/components/power-select/options", "media/components/power-select/options");